// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__12FJO","actionsCol":"EnrolledClinics_actionsCol__2k5r7"};